import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { AthleteKiloClass, AthleteKiloClassesCreate, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCreateAthleteClasses(): UseMutationResult<
  AxiosResponse<AthleteKiloClass>,
  AxiosError<ErrorMessage>,
  AthleteKiloClassesCreate
> {
  const queryClient = useQueryClient();

  const createAthleteClasses = (
    athleteClasses: AthleteKiloClassesCreate,
  ): Promise<AxiosResponse<AthleteKiloClass>> => {
    return client.post('athlete-kilo-classes/create-bulk/', athleteClasses);
  };

  return useMutation(createAthleteClasses, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athleteEvents'],
      });
      queryClient.invalidateQueries({
        queryKey: ['classes'],
      });
      queryClient.invalidateQueries({
        queryKey: 'events',
      });
      queryClient.invalidateQueries({
        queryKey: ['totalAttended'],
      });
      queryClient.invalidateQueries({
        queryKey: ['totalReserved'],
      });
    },
  });
}
